import AuthSignUpIntro from "legacy/auth/AuthSignUpIntro"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: Amplitude is loaded globally

// Renders a "Sign Up" button. On click, opens a modal hosting
// AuthSignUpIntro — the two-box "I'm A Boater" / "I'm A Marina" splash that
// routes the user to /users/sign_up or /claim.
class SignUpLauncher extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showModal: false }
    this.launch = this.launch.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  componentDidMount() {
    // The navbar passes `force` when the URL has `?sign-up-action=` so the
    // modal auto-opens.
    if (this.props.force) {
      this.launch()
    }
  }

  launch(event) {
    event?.preventDefault()
    if (this.props.amplitudeEvent) {
      Amplitude.trackEvent(
        this.props.amplitudeEvent.eventName,
        this.props.amplitudeEvent.eventProperties
      )
    }
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  render() {
    return (
      <div className={this.props.customClass}>
        <button type="button" className="btn btn-danger" onClick={this.launch}>
          {this.props.customLabel || "Sign Up"}
        </button>
        {this.state.showModal && (
          <Modal isOpen onClose={this.closeModal} size="small">
            <Modal.Body>
              <div className="auth-modal mt-4">
                <div className="modal-body">
                  <AuthSignUpIntro />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    )
  }
}

SignUpLauncher.propTypes = {
  amplitudeEvent: PropTypes.shape({
    eventName: PropTypes.string.isRequired,
    eventProperties: PropTypes.object,
  }),
  customClass: PropTypes.string,
  customLabel: PropTypes.string,
  force: PropTypes.bool,
}

SignUpLauncher.defaultProps = {
  customClass: "",
  force: false,
}

export default SignUpLauncher
